import React from 'react';
import { ShieldCheck, MapPinned, Handshake, Timer, BadgeCheck, BarChart3 } from 'lucide-react';
import Reveal from '@/components/site/Reveal';
import SectionHeading from '@/components/site/SectionHeading';

const CARDS = [
  { icon: MapPinned, title: 'Market Expertise', desc: "Deep understanding of Hyderabad's commercial real estate micro-markets." },
  { icon: Handshake, title: 'Strong Tenant Network', desc: 'Active relationships with corporates, coworking operators, retailers, and growing businesses.' },
  { icon: Timer, title: 'Faster Occupancy', desc: 'Targeted leasing strategies that reduce vacancy windows and minimise rental drag.' },
  { icon: BarChart3, title: 'Property Value Enhancement', desc: 'Disciplined leasing and management that compounds long-term asset returns.' },
  { icon: ShieldCheck, title: 'Professional Management', desc: 'Transparent processes, vendor scorecards, and proactive property oversight.' },
  { icon: BadgeCheck, title: 'End-to-End Solutions', desc: 'One trusted partner from leasing strategy through ongoing asset management.' },
];

export default function WhyChoose() {
  return (
    <section data-testid="home-why-choose" className="py-20 md:py-28 bg-white">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading
            kicker="Why Cespedis"
            title="Built for landlords and developers who measure outcomes."
            subtitle="Six reasons our clients consistently choose us for leasing mandates and ongoing property management."
            align="center"
            className="text-center mx-auto"
          />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((c, idx) => (
            <Reveal key={c.title} delay={idx * 70}>
              <div className="group relative h-full overflow-hidden rounded-xl border border-slate-200 bg-white p-7 shadow-sm hover:shadow-md transition-shadow">
                <span className="absolute top-0 left-0 h-[3px] w-12 bg-[#C6A35B]" />
                <div className="flex h-12 w-12 items-center justify-center rounded-md bg-[#144726] text-[#C6A35B]">
                  <c.icon className="h-6 w-6" />
                </div>
                <h3 className="mt-5 text-lg font-semibold text-[#144726]">{c.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{c.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
